import CloseIcon from "@mui/icons-material/Close";
import { OPCIONES_FILTRO_CEDULA } from "../../utils/filtroCedula";
import { OPCIONES_FILTRO_GESTION_INGRESO } from "../../utils/estadosGestionIngreso";

interface FilterChipsProps {
  localStorageFilter: string;
  setFormFilter: (val: any) => void;
  /** Labels adicionales por tabla; se combinan con los por defecto. */
  labels?: Record<string, string>;
}

const FILTER_LABELS: Record<string, string> = {
  nombre: "Nombre",
  rut: "RUT",
  proceso: "ID Proceso",
  cliente: "Cliente",
  fechaPostulacion: "Fecha Postulación",
  fechaValidacion: "Fecha Validación",
  fechaPreseleccion: "Fecha Preselección",
  confirmaEntrevista: "Confirma Entrevista",
  transporteTeamwork: "Transporte TW",
  entrevistaRealizada: "Entrevista Realizada",
  reclutador: "Reclutador",
  cedula: "Validación",
  estadoIngreso: "Estado",
};

/**
 * Rótulo legible de los valores que viajan como código. El filtro de cédula
 * guarda el veredicto del motor ("requiere_revision"), que no es algo que
 * deba leer un reclutador: el chip muestra la misma etiqueta del filtro.
 */
const VALUE_LABELS: Record<string, Record<string, string>> = {
  cedula: Object.fromEntries(OPCIONES_FILTRO_CEDULA.map(({ valor, etiqueta }) => [valor, etiqueta])),
  estadoIngreso: Object.fromEntries(OPCIONES_FILTRO_GESTION_INGRESO.map(({ valor, etiqueta }) => [valor, etiqueta])),
};

const EXCLUDED_KEYS = new Set(["tipoProceso", "estado"]);

const FilterChips = ({
  localStorageFilter,
  setFormFilter,
  labels,
}: FilterChipsProps) => {
  const stored = localStorage.getItem(localStorageFilter);
  if (!stored) return null;

  let parsed: Record<string, any> = {};
  try {
    parsed = JSON.parse(stored);
  } catch {
    return null;
  }

  const labelMap = { ...FILTER_LABELS, ...(labels ?? {}) };

  const chips = Object.entries(parsed)
    .filter(([key, val]) => !EXCLUDED_KEYS.has(key) && Array.isArray(val) && val.length > 0)
    .flatMap(([key, values]) =>
      (values as string[]).map((val, i) => ({
        id: `${key}-${i}`,
        label: labelMap[key] ?? key,
        value: VALUE_LABELS[key]?.[val] ?? val,
      }))
    );

  if (chips.length === 0) return null;

  const handleClearAll = () => {
    const cleared = Object.fromEntries(
      Object.keys(parsed).map((key) => [key, []])
    );
    localStorage.setItem(localStorageFilter, JSON.stringify(cleared));
    setFormFilter(cleared);
  };

  return (
    <div className="filter-chips-row">
      <span className="filter-chips-title">Filtros activos:</span>
      {chips.map(({ id, label, value }) => (
        <span key={id} className="filter-chip">
          <span className="filter-chip-key">{label}</span>
          <span className="filter-chip-val">{value}</span>
        </span>
      ))}
      <button className="filter-chips-clear" onClick={handleClearAll} title="Limpiar todos los filtros">
        <CloseIcon style={{ fontSize: 13 }} />
        Limpiar
      </button>
    </div>
  );
};

export default FilterChips;
